<template>
  <span v-resize="checkMobile" :class="$vuetify.theme.dark ? 'dark' : ''" data-testid="new-calendar-page">
    <fullscreen ref="fullscreen" @change="fullscreenChange">
      <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
        :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
      <v-alert dense text type="warning" border="left" class="ma-2 mb-3" data-testid="calendar-deprecation-banner">
        <div class="d-flex align-center flex-wrap">
          <span class="mr-3">{{ $t("calendar_deprecation.message") }}</span>
          <v-btn small color="primary" to="/calendars/gantt" class="my-1">
            {{ $t("calendar_deprecation.link") }}
          </v-btn>
        </div>
      </v-alert>
      <v-toolbar dense v-if="!isMobile" class="start-tour-calendar-1">
        <v-checkbox class="mt-5" :label="$t('cars.econom')" v-model="showEconom"></v-checkbox>
        <v-spacer></v-spacer>
        <v-checkbox class="mt-5" :label="$t('cars.middle')" v-model="showMiddle"></v-checkbox>
        <v-spacer></v-spacer>
        <v-checkbox class="mt-5" :label="$t('cars.business')" v-model="showBusiness"></v-checkbox>
        <v-spacer></v-spacer>
        <v-checkbox class="mt-5" :label="$t('cars.commercial')" v-model="showCommercial"></v-checkbox>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('custom.search')" single-line clearable
          hide-details></v-text-field>
        <v-btn icon @click="hourly_view = !hourly_view" :color="hourly_view ? 'warning' : ''">
          <v-icon>mdi-timetable</v-icon>
        </v-btn>
        <v-btn icon @click="toggleFinanceMode()" :color="financeMode ? 'success' : ''">
          <v-icon class="mb-1">mdi-cash-multiple</v-icon>
        </v-btn>
        <v-btn icon @click="toggleHistoryMode()" :color="history_mode ? 'warning' : ''" v-tooltip="{
          content: $t('bookings.history_mode'),
          placement: 'bottom-center',
          classes: ['info'],
          targetClasses: ['it-has-a-tooltip'],
          delay: {
            show: 500,
            hide: 500,
          },
        }">
          <v-icon>mdi-history</v-icon>
        </v-btn>
        <v-btn icon @click="showOnlyFreeCars = !showOnlyFreeCars" :color="showOnlyFreeCars ? 'red' : ''">
          <v-icon>mdi-home-circle-outline</v-icon>
        </v-btn>
        <v-btn v-if="!fullscreen" icon @click="toggleFullscreen()">
          <v-icon>mdi-fullscreen</v-icon>
        </v-btn>
        <v-btn v-else icon @click="toggleFullscreen()">
          <v-icon>mdi-fullscreen-exit</v-icon>
        </v-btn>
        <!-- <v-btn icon to="/calendars/bookings">
          <v-icon v-tooltip="{
            content: $t('other.old_calendar'),
            placement: 'bottom-center',
            classes: ['info'],
            targetClasses: ['it-has-a-tooltip'],
            delay: {
              show: 500,
              hide: 500,
            },
          }">mdi-calendar-month-outline</v-icon>
        </v-btn> -->
        <div v-if="!isLoadingOnTop" :class="'pulse mt-3 mx-2 ' + (connected ? 'pulse_success' : 'pulse_error')
          " v-tooltip="{
            content: connected
              ? $t('custom.connected')
              : $t('custom.disconnected'),
            placement: 'bottom-center',
            classes: ['info'],
            targetClasses: ['it-has-a-tooltip'],
            delay: {
              show: 500,
              hide: 500,
            },
          }">
        </div>
        <v-icon size="20" color="info" v-if="isLoadingOnTop" class="mt-1 mx-2">mdi-head-sync-outline</v-icon>
        <v-btn icon :href="docsLink('/kalendar/zagruzka')" target="_blank">
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
      </v-toolbar>
      <v-toolbar v-else :height="showFilters ? '100px' : '50px'" text :color="$vuetify.theme.dark ? '' : 'white'"
        class="mb-1 start-tour-calendar-1">
        <v-flex md12 class="text-center" justify-center>
          <v-flex md12 class="mt-0 d-flex align-center">
            <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('custom.search')" single-line clearable
              hide-details></v-text-field>
            <v-flex>
              <v-icon v-if="!showFilters" @click="showFilters = !showFilters">
                mdi-chevron-down
              </v-icon>
              <v-icon v-else @click="showFilters = !showFilters">
                mdi-chevron-up
              </v-icon>
            </v-flex>
            <v-icon @click="hourly_view = !hourly_view" :color="hourly_view ? 'warning' : ''">
              mdi-timetable
            </v-icon>
            <v-icon @click="toggleFinanceMode()" :color="financeMode ? 'success' : ''"
              class="mx-2 mb-1">mdi-cash-multiple</v-icon>
            <v-icon @click="toggleHistoryMode()" :color="history_mode ? 'warning' : ''">mdi-history</v-icon>
          </v-flex>
          <v-flex md12 class="mt-2" v-if="showFilters">
            <v-flex md6 class="d-flex">
              <v-checkbox class="" :label="$t('cars.econom')" v-model="showEconom" hide-details></v-checkbox>
              <v-spacer></v-spacer>
              <v-checkbox class="mr-12" :label="$t('cars.middle')" v-model="showMiddle" hide-details></v-checkbox>
            </v-flex>
            <v-flex md6 class="d-flex">
              <v-checkbox class="" :label="$t('cars.business')" v-model="showBusiness" hide-details></v-checkbox>
              <v-spacer></v-spacer>
              <v-checkbox class="" :label="$t('cars.commercial')" v-model="showCommercial" hide-details></v-checkbox>
            </v-flex>
          </v-flex>
        </v-flex>
      </v-toolbar>

      <timeline v-if="!isMobile" ref="timeline" :items="items" :groups="filtered_groups"
        :options="hourly_view ? optionsHourly : options"
        :events="['doubleClick', 'changed', 'click', 'rangechange', 'rangechanged']" @double-click="showBooking($event)"
        @rangechange="rangechange($event)" @rangechanged="rangechanged($event)">
      </timeline>
      <timeline v-else ref="timeline" :items="items" :groups="filtered_groups"
        :options="hourly_view ? optionsHourlyMobile : options" :events="['click', 'rangechanged']"
        @click="showBooking($event)" @rangechanged="rangechanged($event)">
      </timeline>
      <v-dialog v-model="dialog" :retain-focus="false" max-width="800px" persistent
        @click:outside="(booking = null), (dialog = false)">
        <v-card v-if="booking">
          <v-card-text>
            <v-container grid-list-md>
              <v-form>
                <v-container>
                  <v-flex md12 class="text-right">
                    <v-btn icon @click="(booking = null), (dialog = false)">
                      <v-icon class="black--text"> mdi-close </v-icon>
                    </v-btn>
                  </v-flex>
                  <v-row no-gutters>
                    <v-col cols="12" sm="12" md="12">
                      <h2 class="m-0 p-0 text-center align-center">
                        {{ $t("bookings.booking") }} {{ $t("custom.number")
                        }}{{ booking.id }}
                        <rent-to-own-chip :booking="booking" class="ml-1" />
                      </h2>
                      <div v-if="!booking.entity">
                        {{ $t("custom.client") }}:
                        <router-link :to="{ path: `/clients/${booking.client_id}` }">{{ clientFullName(booking.client) }}</router-link>
                      </div>
                      <div v-else>
                        {{ $t("custom.client") }}:
                        <router-link :to="{ path: `/clients/${booking.client_id}` }">{{ booking.entity_name
                          }}</router-link>
                      </div>
                      <div>
                        {{ $t("custom.phone") }}:
                        <a :href="telHref(booking.client.phone)">{{
                          formatPhone(booking.client.phone)
                        }}</a>
                      </div>
                      <div>
                        {{ $t("custom.car_long", { msg: object_name_for_label }) }}:
                        <router-link :to="{ path: `/cars/${booking.car_id}` }">{{ booking.car_name }} -
                          {{ booking.car_code }}</router-link>
                      </div>
                      <div>
                        {{ $t("bookings.start_date") }}:
                        {{ booking.start_date }}
                      </div>
                      <div>
                        {{ $t("bookings.end_date") }}: {{ booking.end_date }}
                      </div>
                      <div>{{ $t("custom.days") }}: {{ booking.days }}</div>
                      <div>
                        {{ $t("bookings.checkin") }}:
                        {{ booking.location_start }}
                      </div>
                      <div>
                        {{ $t("bookings.checkout") }}:
                        {{ booking.location_end }}
                      </div>
                      <!-- <td v-if="company && company.multicurrency_cashboxes" class="text-center">
                            {{ count.operation ? "" : "-" }}{{ count.sum }}{{ findCurrencySymbol(count.currency_id) }}
                            <span v-if="count.rate && (count.rate != 1 && count.rate != 0) && count.rate != null">
                              ({{ count.rated_sum }})
                            </span>
                          </td>
                          <td v-else class="text-center">
                            {{ count.operation ? "" : "-" }}{{ count.sum }}{{ currency }}
                          </td> -->
                      <div v-if="company && company.multicurrency_cashboxes">
                        {{ $t("bookings.day_price") }}: {{ booking.price
                        }}{{ findCurrencySymbol(base_currency_id) }}
                      </div>
                      <div v-else>
                        {{ $t("bookings.day_price") }}: {{ booking.price
                        }}{{ currency }}
                      </div>
                      <div v-if="company && company.multicurrency_cashboxes">
                        {{ $t("bookings.deposit") }}: {{ bookingDeposit(booking)
                        }}{{ findCurrencySymbol(base_currency_id) }}
                      </div>
                      <div v-else>
                        {{ $t("bookings.deposit") }}: {{ bookingDeposit(booking)
                        }}{{ currency }}
                      </div>
                      <div v-if="company && company.multicurrency_cashboxes">
                        {{ $t("bookings.rental_cost") }}:
                        {{ booking.rental_cost }}{{ findCurrencySymbol(base_currency_id) }}
                      </div>
                      <div v-else>
                        {{ $t("bookings.rental_cost") }}:
                        {{ booking.rental_cost }}{{ currency }}
                      </div>
                      <div v-if="company && company.multicurrency_cashboxes">
                        {{ $t("bookings.total") }}:
                        {{ booking.total + bookingDeposit(booking) }}{{ findCurrencySymbol(base_currency_id) }}
                      </div>
                      <div v-else>
                        {{ $t("bookings.total") }}:
                        {{ booking.total + bookingDeposit(booking) }}{{ currency }}
                      </div>
                      <div v-if="booking.additional_hours > 0 && company && company.multicurrency_cashboxes">
                        {{ $t("bookings.add_hours") }}:
                        {{ booking.additional_hours }}{{ findCurrencySymbol(base_currency_id) }}
                      </div>
                      <div v-if="booking.additional_hours > 0 && company && !company.multicurrency_cashboxes">
                        {{ $t("bookings.add_hours") }}:
                        {{ booking.additional_hours }}
                      </div>
                      <div v-if="booking.additional_hours > 0 && company && company.multicurrency_cashboxes">
                        {{ $t("bookings.hours_cost") }}: {{ booking.hours_cost
                        }}{{ findCurrencySymbol(base_currency_id) }}
                      </div>
                      <div v-if="booking.additional_hours > 0 && company && !company.multicurrency_cashboxes">
                        {{ $t("bookings.hours_cost") }}: {{ booking.hours_cost
                        }}{{ currency }}
                      </div>
                      <div v-if="booking.delivery > 0 && company && company.multicurrency_cashboxes">
                        {{ $t("bookings.delivery") }}: {{ booking.delivery
                        }}{{ findCurrencySymbol(base_currency_id) }}
                      </div>
                      <div v-if="booking.delivery > 0 && company && !company.multicurrency_cashboxes">
                        {{ $t("bookings.delivery") }}: {{ booking.delivery
                        }}{{ currency }}
                      </div>
                      <div v-if="booking.delivery_end > 0 && company && company.multicurrency_cashboxes">
                        {{ $t("bookings.checkout") }}: {{ booking.delivery_end
                        }}{{ findCurrencySymbol(base_currency_id) }}
                      </div>
                      <div v-if="booking.delivery_end > 0 && company && !company.multicurrency_cashboxes">
                        {{ $t("bookings.checkout") }}: {{ booking.delivery_end
                        }}{{ currency }}
                      </div>
                      <div v-if="booking.equipment > 0 && company && company.multicurrency_cashboxes">
                        {{ $t("bookings.equipment") }}: {{ booking.equipment
                        }}{{ findCurrencySymbol(base_currency_id) }}
                      </div>
                      <div v-if="booking.equipment > 0 && company && !company.multicurrency_cashboxes">
                        {{ $t("bookings.equipment") }}: {{ booking.equipment
                        }}{{ currency }}
                      </div>
                      <div v-if="booking.other > 0 && company && company.multicurrency_cashboxes">
                        {{ $t("bookings.for_other") }}: {{ booking.other
                        }}{{ findCurrencySymbol(base_currency_id) }}
                      </div>
                      <div v-if="booking.other > 0 && company && !company.multicurrency_cashboxes">
                        {{ $t("bookings.for_other") }}: {{ booking.other
                        }}{{ currency }}
                      </div>
                      <div v-if="booking.description">
                        <h3>{{ $t("bookings.description") }}</h3>
                        <p>{{ booking.description }}</p>
                      </div>
                      <v-flex md12 class="text-center">
                        <v-btn class="mt-2" @click="replaceToBooking(booking)">{{ $t("bookings.description_2") }}
                        </v-btn>
                      </v-flex>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </fullscreen>
  </span>
</template>

<script>
import { clientFullName } from "@/utils/personName";
import { Timeline, DataSet } from "vue-visjs";
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { Capacitor } from "@capacitor/core";
const mdi_spray_bottle = 'data:image/svg+xml, ' + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" fill="#795548" viewBox="0 0 24 24"><title>spray-bottle</title><path d="M16.72 10.43C14.68 8.39 14.5 4.66 14.5 4H13V6H9V4H7C7 2.9 7.9 2 9 2H16V3C16 3.08 16.04 7.63 17.78 9.37L16.72 10.43M17 2V4H18V2H17M15 12C13 10 13 7 13 7H9V9C9 10 9 10 8 11S7 13 7 13V20C7 21.1 7.9 22 9 22H13C14.1 22 15 21.1 15 20V12Z" /></svg>`)
const mdi_flare = 'data:image/svg+xml, ' + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" fill="#2196f3" viewBox="0 0 24 24"><title>flare</title><path d="M7,11H1V13H7V11M9.17,7.76L7.05,5.64L5.64,7.05L7.76,9.17L9.17,7.76M13,1H11V7H13V1M18.36,7.05L16.95,5.64L14.83,7.76L16.24,9.17L18.36,7.05M17,11V13H23V11H17M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M14.83,16.24L16.95,18.36L18.36,16.95L16.24,14.83L14.83,16.24M5.64,16.95L7.05,18.36L9.17,16.24L7.76,14.83L5.64,16.95M11,23H13V17H11V23Z" /></svg>`)
const mdi_battery = 'data:image/svg+xml, ' + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" fill="#8bc34a" viewBox="0 0 24 24"><title>battery</title><path d="M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67A1.33,1.33 0 0,0 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z" /></svg>`)
const mdi_battery_10 = 'data:image/svg+xml, ' + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" fill="#F44336" viewBox="0 0 24 24"><title>battery-10</title><path d="M16,18H8V6H16M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67A1.33,1.33 0 0,0 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z" /></svg>`)
const mdi_manual = 'data:image/svg+xml, ' + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" fill="#ff9800" viewBox="0 0 24 24"><title>car-shift-pattern</title><path d="M8 5H4V2H8V5M4 22H8V19H4V22M14 2H10V5H14V2M10 22H14V19H10V22M16 2V5H20V2H16M17 11H13V7H11V11H7V7H5V17H7V13H11V17H13V13H19V7H17V11Z" /></svg>`)
const mdi_automat = 'data:image/svg+xml, ' + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" fill="#ff9800" viewBox="0 0 24 24"><title>alpha-a-circle</title><path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M11,7A2,2 0 0,0 9,9V17H11V13H13V17H15V9A2,2 0 0,0 13,7H11M11,9H13V11H11V9Z" /></svg>`)
const mdi_plus = 'data:image/svg+xml, ' + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" fill="#8bc34a" viewBox="0 0 24 24"><title>plus-circle</title><path d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>`)
import CableSubscriber from "@/mixins/CableSubscriber";
// Залог брони по типу аренды: у почасовой, недельной и месячной он лежит
// в своём поле, а не в booking.deposit. Псевдоним — чтобы одноимённый
// метод-прокси для шаблона не читался как рекурсия.
import { bookingDeposit as depositForBooking } from "@/components/dashboard/bookings/addonsMath";
import RentToOwnChip from "@/components/dashboard/bookings/RentToOwnChip.vue";
import rentalObjectMixin from "@/mixins/rentalObjectMixin";
import { formatPhone, telHref } from "@/lib/phone/display";

// FT-173 REQ-14: тег «Выкуп» в HTML-тултипе vis-timeline. Чистая функция: у обычного
// бронирования сразу пустая строка — путь обычных бронирований не трогает ни this, ни $t
// (обработчики кабеля вызываются и на минимальном контексте, wiring-calendar.spec.js).
function rentToOwnTooltipTag(booking, translate) {
  if (!booking || booking.rent_to_own !== true) return "";
  return `<br /><b class="rent-to-own-tag">${translate("rent_to_own.chip_label")}</b>`;
}

export default {
  mixins: [CableSubscriber, rentalObjectMixin],
  data() {
    return {
      cars: [],
      all_cars: [],
      items: [],
      all_items: [],
      groups: [
        {
          id: 0,
          content: "",
        },
      ],
      all_groups: [],
      finded_booking: null,
      showFilters: false,
      booking: null,
      dialog: false,
      hourly_view: false,
      finance_mode: false,
      history_mode: false,
      options: {
        // editable: {
        //   add: true, // add new items by double tapping
        //   updateTime: true, // drag items horizontally
        //   updateGroup: true, // drag items from one group to another
        //   remove: false, // delete an item by tapping the delete button top right
        //   overrideItems: false, // allow these options to override item.editable
        // },
        // cluster: true,
        maxHeight: "1000px",
        orientation: "both",
        // itemsAlwaysDraggable: true,
        // zoomMax: 2629800000, // 1 month
        // zoomMin: 604800000, // 1 month
        timeAxis: { scale: "day", step: 1 },
        zoomMax: this.$vuetify.breakpoint.smAndDown ? 1604800000 / 1.5 : 1604800000 * 6, // 1 month
        zoomMin: this.$vuetify.breakpoint.smAndDown ? 1604800000 / 8 : 1604800000, // 1 month
        // minHeight: "500px",
        start: moment().subtract(7, "day"),
        // end: new Date(100000 * 60 * 60 * 24 + new Date().valueOf()),
        locale: "ru",
        // locales: {
        //   // create a new locale (text strings should be replaced with localized strings)
        //   mylocale: {
        //     current: 'current',
        //     time: 'time',
        //     deleteSelected: 'Delete selected',
        //     months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
        //     monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
        //     weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        //     weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        //     weekdaysMin: "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
        //   }
        // },
        // // use the new locale
        // locale: 'mylocale',
        // horizontalScroll: false,
        rollingMode: {
          follow: true,
          offset: 0.1,
        },
        groupOrder: function (a, b) {
          return a.sort - b.sort;
        },
        rtl: false,
        type: "range",
        verticalScroll: true,
        stack: true,
        // stack: false,
        align: "auto",
        groupHeightMode: "auto",
        zoomable: true,
        zoomKey: "ctrlKey",
        moveable: true,
        selectable: false,
        // selectable: true,
        autoResize: true,
        format: {
          minorLabels: {
            day: "D",
          },
        },
        margin: {
          item: {
            horizontal: 0,
          },
        },
      },
      optionsHourly: {
        maxHeight: "1000px",
        orientation: "both",
        timeAxis: { scale: "hour", step: 1 },
        zoomMax: 46048000, // 1 day
        zoomMin: 14800, // 1 day
        start: moment().subtract(36, "hour"),
        // end: new Date(100000 * 60 * 60 * 24 + new Date().valueOf()),
        locale: this.$i18n.locale,
        rollingMode: {
          follow: true,
          offset: 0.1,
        },
        groupOrder: function (a, b) {
          return a.sort - b.sort;
        },
        rtl: false,
        type: "range",
        verticalScroll: true,
        stack: true,
        // stack: false,
        align: "auto",
        groupHeightMode: "auto",
        zoomable: true,
        zoomKey: "ctrlKey",
        moveable: true,
        selectable: false,
        // selectable: true,
        autoResize: true,
        format: {
          minorLabels: {
            day: "D",
          },
        },
        margin: {
          item: {
            horizontal: 0,
          },
        },
      },
      optionsHourlyMobile: {
        maxHeight: "1000px",
        orientation: "both",
        timeAxis: { scale: "hour", step: 1 },
        zoomMax: 26048000, // 1 day
        zoomMin: 14800, // 1 day
        start: moment().subtract(36, "hour"),
        // end: new Date(100000 * 60 * 60 * 24 + new Date().valueOf()),
        locale: this.$i18n.locale,
        rollingMode: {
          follow: true,
          offset: 0.1,
        },
        groupOrder: function (a, b) {
          return a.sort - b.sort;
        },
        rtl: false,
        type: "range",
        verticalScroll: true,
        stack: true,
        // stack: false,
        align: "auto",
        groupHeightMode: "auto",
        zoomable: true,
        zoomKey: "ctrlKey",
        moveable: true,
        selectable: false,
        // selectable: true,
        autoResize: true,
        format: {
          minorLabels: {
            day: "D",
          },
        },
        margin: {
          item: {
            horizontal: 0,
          },
        },
      },
      mobileOptions: {
        maxHeight: "500px",
        orientation: "top",
        // itemsAlwaysDraggable: true,
        timeAxis: { scale: "day", step: 1 },
        // zoomMax: 2629800000, // 1 month
        // zoomMin: 604800000, // 1 month
        zoomMax: 604800000, // 1 month
        zoomMin: 604800000, // 1 month
        // minHeight: "500px",
        start: new Date(),
        locale: "ru",
        // horizontalScroll: false,
        rollingMode: {
          follow: true,
          offset: 0,
        },
        type: "range",
        verticalScroll: true,
        stack: false,
        align: "center",
        zoomable: false,
        // moveable: true,
        selectable: false,
        autoResize: true,
        // editable: {
        //   add: true, // add new items by double tapping
        //   updateTime: true, // drag items horizontally
        //   updateGroup: true, // drag items from one group to another
        //   remove: true, // delete an item by tapping the delete button top right
        //   overrideItems: false // allow these options to override item.editable
        // },
      },
      windowHeight: "550px",
      fullscreen: false,
      previous_start: null,
      search: null,
      showOnlyFreeCars: false,
      showEconom: false,
      showMiddle: false,
      showBusiness: false,
      showCommercial: false,
      connected: false,
      isLoading: false,
      isLoadingOnTop: false,
      isMobile: false,
      error: "",
    };
  },
  mounted() {
    console.log(this.isMobile, this.options.zoomMax, this.options.zoomMin);
    this.checkMobile();
    // Паритет с остальными cable-подписками (см. TimelineCalendar).
    if ((this.isStaff || this.isAgent) &&
        this.$store.getters.getCompany && 
        this.$store.getters.getCompany.company && 
        this.$store.getters.getCompany.company.id) {
      // FT-066: native held-ref CalendarChannel sub; handlers via arrows (this-rebinding).
      // Own per-instance object → no name collision with GanttCalendar's CalendarChannel.
      this.calendarSub = this.$cableSubscribe(
        { channel: "CalendarChannel", room: this.$store.getters.getCompany.company.id },
        {
          connected: () => this.onCalendarConnected(),
          disconnected: () => this.onCalendarDisconnected(),
          received: (data) => this.onCalendarReceived(data),
        }
      );
    }
    if (
      this.$tours["registrationTour"] &&
      this.$store.getters.getTourNextStep
    ) {
      this.$tours["registrationTour"].nextStep();
    }
    if (this.$store.getters.getCompany && 
        this.$store.getters.getCompany.company && 
        this.$store.getters.getCompany.company.rent_type == 1) {
      this.hourly_view = true;
    }
  },
  created() {
    let self = this;
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      window.addEventListener("resize", () => {
        this.windowHeight = window.innerHeight;
      });
      this.windowHeight = window.innerHeight;
      if (this.isMobile || this.isNative) {
        this.options.maxHeight = this.windowHeight - 145 + "px";
      } else {
        this.options.maxHeight = this.windowHeight - 195 + "px";
      }
      this.loadBookings(moment().subtract(36, "hour").format("DD-MM-YYYY H:mm"), moment().add(34, "days").format("DD-MM-YYYY H:mm"), true, this.history_mode);
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  beforeDestroy() {
    // Timeline.destroy();
    // FT-066: CableSubscriber mixin auto-unsubscribes the held CalendarChannel ref.
    this.$cableUnsubscribe(this.calendarSub);
    this.calendarSub = null;
  },
  components: {
    timeline: Timeline,
    RentToOwnChip,
  },
  computed: {
    filtered_groups() {
      // Search
      if (
        this.showOnlyFreeCars ||
        (this.search && this.search.length > 0 && this.search != " ") ||
        this.showEconom ||
        this.showMiddle ||
        this.showBusiness ||
        this.showCommercial
      ) {
        if (this.search && this.search.length > 0 && this.search != " ") {
          return this.groups.filter((group) => {
            return group.content
              .toLowerCase()
              .includes(this.search.toLowerCase());
          });
        }
        if (
          this.showEconom ||
          this.showMiddle ||
          this.showBusiness ||
          this.showCommercial
        ) {
          let filtered_cars_ids = [];
          if (this.showEconom) {
            this.cars.forEach((car) => {
              if (car.car_class == "Эконом") {
                filtered_cars_ids.push(car.id);
              }
            });
          }
          if (this.showMiddle) {
            this.cars.forEach((car) => {
              if (car.car_class == "Средний") {
                filtered_cars_ids.push(car.id);
              }
            });
          }
          if (this.showBusiness) {
            this.cars.forEach((car) => {
              if (car.car_class == "Бизнес") {
                filtered_cars_ids.push(car.id);
              }
            });
          }
          if (this.showCommercial) {
            this.cars.forEach((car) => {
              if (car.car_class == "Коммерческий") {
                filtered_cars_ids.push(car.id);
              }
            });
          }
          return this.groups.filter((car) => {
            return filtered_cars_ids.includes(car.id);
          });
        }
        if (this.showOnlyFreeCars) {
          let now = moment();
          let free_cars_ids = [];
          this.items.forEach((item) => {
            if (now.isBetween(moment(item.start), moment(item.end), "hour")) {
              free_cars_ids.push(item.group);
            }
          });
          return this.groups.filter((car) => {
            return !free_cars_ids.includes(car.id);
          });
        }
        return undefined;
      } else {
        return this.groups;
      }
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    active_company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id && cashbox.is_active) {
            cashboxes.push(cashbox);
          }
        });
        cashboxes.sort((a, b) => {
          // сортировка по is_default
          if (a.is_default && !b.is_default) {
            return -1;
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    base_currency_id() {
      if (this.active_company_cashboxes && this.active_company_cashboxes.length > 0) {
        return this.active_company_cashboxes.find((cashbox) => cashbox.is_default).currency_id;
      } else {
        return null;
      }
    },
    currencies() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currencies
      ) {
        return this.$store.getters.getCompany.company.currencies;
      } else {
        return [];
      }
    },
    getUserSettings() {
      if (
        this.$store.getters.getUserSettings
      ) {
        return this.$store.getters.getUserSettings;
      } else {
        return null;
      }
    },
    financeMode() {
      return this.$store.getters.getFinanceMode;
    },
    company() {
      return this.$store.getters.getCompany.company;
    },
    currentUser() {
      return this.$store.getters.getCurrentUser;
    },
  },
  watch: {
    showFilters() {
      if (this.showFilters) {
        this.options.maxHeight = this.windowHeight - 195 + "px";
      } else {
        this.options.maxHeight = this.windowHeight - 145 + "px";
      }
    },
  },
  methods: {
    formatPhone,
    telHref,
    clientFullName,
    bookingDeposit(booking) {
      return depositForBooking(booking);
    },
    // FT-066: CalendarChannel handlers (moved 1:1 from the old declarative channel).
    onCalendarConnected() {
      this.connected = "success";
    },
    onCalendarDisconnected() {
      this.connected = "error";
    },
    onCalendarReceived(data) {
      if (data.action == "car") {
        let finded_car = this.groups.findIndex(
          (item) => item.id == data.car.id
        );
        if (finded_car > -1) {
          let car_data = {
            id: data.car.id,
            content: data.car.code,
            className: this.returnCarStateColor(data.car.state),
            sort: data.car.sort,
          };
          this.groups.splice(finded_car, 1, car_data);
        }
      }
      let self = this;
      let finded_item = this.items.findIndex(
        (item) => item.id == data.booking.id
      );
      if (data.booking.active) {
        let updated_booking = {
          id: data.booking.id,
          title: `<p class='timeline-tooltip'>
                            <b>${data.booking.id} ${data.booking.location_start} ${data.booking.start_date} - ${data.booking.location_end} ${data.booking.end_date}</b>
                            <br />
                            <b>${data.booking.last_name} ${data.booking.first_name} ${data.booking.middle_name}</b>${rentToOwnTooltipTag(data.booking, (key) => this.$t(key))}
                            </p>`,

          content: `${data.booking.location_start} ${moment(
            data.booking.start_date,
            "DD-MM-YYYY H:mm"
          ).format("H:mm")} - ${data.booking.location_end} ${moment(
            data.booking.end_date,
            "DD-MM-YYYY H:mm"
          ).format("H:mm")}`,
          start: moment(data.booking.start_date, [
            "DD-MM-YYYY H:mm",
            "DD-MM-YYYY HH:mm",
          ]),
          end: moment(data.booking.end_date, [
            "DD-MM-YYYY H:mm",
            "DD-MM-YYYY HH:mm",
          ]),
          group: data.booking.car_id,
          className: self.bookingColor(data.booking),
        };
        if (finded_item == -1) {
          this.items.push(updated_booking);
        } else {
          this.items.splice(finded_item, 1, updated_booking);
        }
      } else {
        if (finded_item != -1) {
          this.items.splice(finded_item, 1);
        }
      }
    },
    loadBookings(start_date, end_date, loading_on, history_mode) {
      if (loading_on) {
        this.isLoading = true;
      }
      this.isLoadingOnTop = true;
      let self = this;
      this.axios
        .get(`/api/v1/index_for_calendar?start=${start_date}&end=${end_date}&history_mode=${history_mode}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.groups = [];
          this.all_groups = [];
          this.cars = [];
          this.items = [];
          let show_icons_on_calendar = this.getUserSettings.show_icons_on_calendar;
          response.data.cars.data.forEach((car) => {
            this.cars.push(car.attributes);
            let transmission_auto = car.attributes.transmission == "Автомат" || car.attributes.transmission == "Вариатор" || car.attributes.transmission == "Робот";
            if (show_icons_on_calendar) {
              this.groups.push({
                id: car.attributes.id,
                content: `
                <div>
                  <div>
                  <a href="/cars/${car.attributes.id
                  }">${car.attributes.code
                  }</a>
                  </div>
                  <div>
                    <img src="${transmission_auto ? mdi_automat : mdi_manual}">
                    <img src="${car.attributes.clean_state ? mdi_flare : mdi_spray_bottle}">
                    ${this.hasFeature("fuel") ? `<img src="${car.attributes.tank_state ? mdi_battery : mdi_battery_10}">` : ""}
                  </div>
                  <div ${this.currentUser.role == "partner" ? "style='display: none;'" : ""}>
                    <a href="/booking/new?car_id=${car.attributes.id}">
                      <img src="${mdi_plus}">
                    </a>
                  </div>
                </div>
                `,
                className: self.returnCarStateColor(car.attributes.state),
                sort: car.attributes.sort,
              });
            } else {
              this.groups.push({
                id: car.attributes.id,
                content: `
                <div>
                  <div>
                  <a href="/cars/${car.attributes.id
                  }">${car.attributes.code
                  }</a>
                  </div>
                </div>
                `,
                className: this.returnCarStateColor(car.attributes.state),
                sort: car.attributes.sort,
              });
            }
            this.all_groups.push({
              id: car.attributes.id,
              content: car.attributes.code,
              className: this.returnCarStateColor(car.attributes.state),
            });
          });
          response.data.bookings.data.forEach((element) => {
            let booking = element.attributes;
            booking.counts = [];
            booking.gifts = [];
            element.relationships.counts.data.forEach((item) => {
              if (response.data.bookings.included) {
                let included_counts = response.data.bookings.included.filter(
                  (count) => count.id == item.id
                );
                included_counts.forEach((count) => {
                  booking.counts.push(count.attributes);
                });
              }
            });
            element.relationships.gifts.data.forEach((item) => {
              if (response.data.bookings.included) {
                let included_gifts = response.data.bookings.included.filter(
                  (gift) => gift.id == item.id
                );
                included_gifts.forEach((gift) => {
                  booking.gifts.push(gift.attributes);
                });
              }
            });
            this.items.push({
              id: booking.id,
              title: `<p class='timeline-tooltip'>
                              <b>${booking.id} ${booking.location_start} ${booking.start_date} - ${booking.location_end} ${booking.end_date}</b>
                              <br />
                              <b>${booking.last_name} ${booking.first_name} ${booking.middle_name}</b>${rentToOwnTooltipTag(booking, (key) => this.$t(key))}
                              </p>`,

              content: `${this.contentOnBooking(booking)}`,
              start: moment(booking.start_date, [
                "DD-MM-YYYY H:mm",
                "DD-MM-YYYY HH:mm",
              ]),
              end: moment(booking.end_date, [
                "DD-MM-YYYY H:mm",
                "DD-MM-YYYY HH:mm",
              ]),
              group: booking.car_id,
              className: this.bookingColor(booking),
            });
          });
          this.items.forEach((item) => this.all_items.push(item));
          // console.log(self.items);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => (this.isLoading = false, this.isLoadingOnTop = false));
    },
    async showBooking(event) {
      // checkPartnerAccess() — async (ходит в /check_partner_access), а его
      // звали без await: Promise всегда истинный, поэтому партнёр НЕ
      // отсеивался вовсе и открывал карточку брони мимо can_view_booking_card.
      // Баг старше ветки, но прежний комментарий утверждал обратное.
      // !currentUser сохранён из исходного условия: без пользователя isAgent
      // и isGuest ложны, а checkPartnerAccess() вернёт true — метод ушёл бы в
      // GET /bookings/:id вместо раннего выхода.
      if (!this.currentUser || this.isAgent || this.isGuest) return;
      if (!(await this.checkPartnerAccess())) return;

      {
        // Блок сохранён от прежнего `if (…) { … }`: внутри объявлены let'ы,
        // и разворачивание тела — отдельная правка, не эта.
        let id = event.item;
        if (event.item) {
          this.isLoading = true;
          let self = this;
          this.axios
            .get(`/api/v1/bookings/${id}`, {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then((response) => {
              this.booking = response.data;
              this.booking.selected_price = this.booking.price;
              this.dialog = true;
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.booking_load"));
            })
            .finally(() => (this.isLoading = false));
        }
      }
    },
    async checkPartnerAccess() {
      if (this.currentUser && this.currentUser.role == "partner") {
        this.isLoading = true;
        let result = false;
        await this.axios.get(`/api/v1/check_partner_access`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        }).then(async (response) => {
          if (response.data.can_view_booking_card) {
            result = true;
          } else {
            result = false;
          }
        })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => (this.isLoading = false));
        return result;
      } else {
        return true;
      }
    },
    // FT-173 STEP-19 (REQ-14) — доп. строка HTML-тултипа vis-timeline для
    // договорных бронирований; обычные (rent_to_own !== true) не меняются.
    rentToOwnTooltipTag(booking) {
      return rentToOwnTooltipTag(booking, (key) => this.$t(key));
    },
    contentOnBooking(booking) {
      // FT-173 H13: у договорного бронирования оплата идёт по графику
      // договора выкупа — «оплачено N из M дней» ввело бы в заблуждение.
      if (this.financeMode && booking && booking.rent_to_own === true) {
        return this.$t("rent_to_own.chip_label");
      }
      if (this.financeMode) {
        return `${this.paidDays(booking)} ${this.$t("other.from")} ${booking.days} ${this.$tc("bookings.days_plural", booking.days)}`;
      } else {
        return `${booking.location_start} ${moment(booking.start_date, "DD-MM-YYYY H:mm").format("H:mm")} - ${booking.location_end} ${moment(booking.end_date, "DD-MM-YYYY H:mm").format("H:mm")}`
      }
    },
    progressPercent(booking) {
      // Договор выкупа — доля оплаты договора из api (см. gantt-utils calcProgressPercent).
      if (booking.rent_to_own === true && booking.rent_to_own_paid_percent != null) {
        return Math.round(Number(booking.rent_to_own_paid_percent));
      }
      if (!booking.hourly && !booking.weekly && !booking.monthly) {
        let percent = (this.calculateRentPaymentsSum(booking) / ((booking.rental_cost - booking.aggr_commission) / this.paidDays(booking)) / this.paidDays(booking)) * 100
        // Integer
        percent = Math.round(percent);
        return percent;
      } else if (booking.hourly) {
        let percent = (this.calculateRentPaymentsSum(booking) / ((booking.rental_cost - booking.aggr_commission) / this.paidHours(booking)) / this.paidHours(booking)) * 100
        // Integer
        percent = Math.round(percent);
        return percent;
      } else if (booking.weekly) {
        let percent = (this.calculateRentPaymentsSum(booking) / ((booking.rental_cost - booking.aggr_commission) / this.paidWeeks(booking)) / this.paidWeeks(booking)) * 100
        // Integer
        percent = Math.round(percent);
        return percent;
      } else if (booking.monthly) {
        let percent = (this.calculateRentPaymentsSum(booking) / ((booking.rental_cost - booking.aggr_commission) / this.paidMonths(booking)) / this.paidMonths(booking)) * 100
        // Integer
        percent = Math.round(percent);
        return percent;
      }
    },
    calculateRentPaymentsSum(booking) {
      if (booking && booking.counts && booking.counts.length > 0) {
        let paid = 0;
        booking.counts.forEach((count) => {
          if (count.group == "Оплата аренды") {
            // если оплата по терминалу и в платеже есть tinkoff_payment_id то учитываем только если count.tinkoff_payment.paid = true
            if (count.completed) {
              if (count.operation) {
                if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                  let ratedSum = Number(count.rated_sum);
                  paid += ratedSum;
                } else {
                  let sum = Number(count.sum);
                  paid += sum;
                }
              } else {
                if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && count.rated_sum != null) {
                  let ratedSum = Number(count.rated_sum);
                  paid -= ratedSum;
                } else {
                  let sum = Number(count.sum);
                  paid -= sum;
                }
              }
            }
          }
        });
        // Округляем сумму до 2 знаков после запятой
        paid = parseFloat(paid.toFixed(2));
        return paid;
      } else {
        return 0;
      }
    },
    paidDays(booking) {
      let days =
        Math.round(
          this.calculateRentPaymentsSum(booking) /
          (booking.rental_cost / booking.days)
        ) || 0;
      if (booking.gifts && booking.gifts.length > 0) {
        let gift_days = 0;
        let gift_paid = 0;
        booking.gifts.forEach((gift) => {
          if (gift.gift_type == 0) {
            gift_days += gift.count;
            gift_paid += gift.count * gift.price;
          }
        });
        let fact_days = days - gift_days;
        days =
          Math.round(
            (this.calculateRentPaymentsSum(booking) /
              ((booking.rental_cost + gift_paid) / days)) *
            100
          ) / 100;
      }
      return days;
    },
    paidHours(booking) {
      let hours =
        Math.round(
          this.calculateRentPaymentsSum(booking) /
          (booking.rental_cost / booking.hourly_hours)
        ) || 0;
      if (booking.gifts && booking.gifts.length > 0) {
        let gift_hours = 0;
        let gift_paid = 0;
        booking.gifts.forEach((gift) => {
          if (gift.gift_type == 0) {
            gift_hours += gift.count;
            gift_paid += gift.count * gift.price;
          }
        });
        let fact_hours = hours - gift_hours;
        hours =
          Math.round(
            (this.calculateRentPaymentsSum(booking) /
              ((booking.rental_cost + gift_paid) / hours)) *
            100
          ) / 100;
      }
      return hours;
    },
    paidWeeks(booking) {
      let weeks =
        Math.round(
          this.calculateRentPaymentsSum(booking) /
          (booking.rental_cost / booking.weekly_weeks)
        ) || 0;
      if (booking.gifts && booking.gifts.length > 0) {
        let gift_weeks = 0;
        let gift_paid = 0;
        booking.gifts.forEach((gift) => {
          if (gift.gift_type == 0) {
            gift_weeks += gift.count;
            gift_paid += gift.count * gift.price;
          }
        });
        let fact_weeks = weeks - gift_weeks;
        weeks =
          Math.round(
            (this.calculateRentPaymentsSum(booking) /
              ((booking.rental_cost + gift_paid) / weeks)) *
            100
          ) / 100;
      }
      return weeks;
    },
    paidMonths(booking) {
      let months =
        Math.round(
          this.calculateRentPaymentsSum(booking) /
          (booking.rental_cost / booking.monthly_months)
        ) || 0;
      if (booking.gifts && booking.gifts.length > 0) {
        let gift_months = 0;
        let gift_paid = 0;
        booking.gifts.forEach((gift) => {
          if (gift.gift_type == 0) {
            gift_months += gift.count;
            gift_paid += gift.count * gift.price;
          }
        });
        let fact_hours = months - gift_months;
        months =
          Math.round(
            (this.calculateRentPaymentsSum(booking) /
              ((booking.rental_cost + gift_paid) / months)) *
            100
          ) / 100;
      }
      return months;
    },
    findCurrencySymbol(id) {
      if (id != null) {
        if (this.currencies.find((currency) => currency.id == id)) {
          return this.currencies.find((currency) => currency.id == id).symbol;
        }
      }
    },
    bookingColor(booking) {
      if (booking.in_rent && !booking.technical) {
        // return this.selectColorPaid(booking);
        return this.selectColorPaid(booking);
      } else if (booking.ride) {
        return "booking_warning";
      } else if (booking.in_rent && booking.technical) {
        return "booking_grey_green";
      } else if (!booking.in_rent && booking.technical) {
        return "booking_grey";
      } else {
        return "booking_blue";
      }
    },
    selectColorPaid(booking) {
      if (booking != undefined) {
        let progressPercent = this.progressPercent(booking)
        // Ноль и меньше (неоплаченный договор выкупа, возвраты) — красная полоска.
        // Раньше ровный 0 уходил в «booking_green_100»: у обычного бронирования без
        // платежей процент — NaN и попадал в последнюю ветку, а ровного нуля не бывало.
        if (!Number.isFinite(progressPercent) || progressPercent <= 0) {
          return "booking_green_0";
        } else if (progressPercent >= 100) {
          return "booking_green_100";
        } else {
          return `booking_green_${progressPercent}`;
        }
      }
    },
    toggleHistoryMode() {
      this.history_mode = !this.history_mode;
      if (this.history_mode) {
        this.loadBookings(moment().subtract(36, "hour").format("DD-MM-YYYY H:mm"), moment().add(34, "days").format("DD-MM-YYYY H:mm"), true, this.history_mode);
        // set calendar to today
        // this.options.start = moment().subtract(36, "hour").format("DD-MM-YYYY H:mm");
        // this.options.end = moment().add(34, "days").format("DD-MM-YYYY H:mm");
        // this.options.timeAxis.scale = "month";
        // this.options.timeAxis.step = 1;

      } else {
        this.loadBookings(moment().subtract(36, "hour").format("DD-MM-YYYY H:mm"), moment().add(34, "days").format("DD-MM-YYYY H:mm"), true, this.history_mode);
      }
    },
    replaceToBooking(booking) {
      this.$router.push({ path: `/bookings/${booking.id}` });
    },
    rangechanged(event) {
      if (event.byUser) {
        let start = moment(event.start).subtract(36, "hour").format("DD-MM-YYYY H:mm");
        let end = moment(event.end).add(34, "days").format("DD-MM-YYYY H:mm");
        this.loadBookings(start, end, false, this.history_mode);
        this.previous_start = event.start;
      } else {
        if (this.previous_start) {
          console.log("loading")
          let start = moment(event.start).subtract(36, "hour").format("DD-MM-YYYY H:mm");
          let end = moment(event.end).add(3, "days").format("DD-MM-YYYY H:mm");
          this.loadBookings(start, end, false, this.history_mode);
          this.previous_start = null;
        }
      }
    },
    rangechange(event) {
      // if (event.byUser) {
      //   console.log("rangechange", event);
      //   // this.options.start = event.start;
      //   // this.options.end = event.end;
      // } else {
      //   console.log("rangechange", event);
      // }
    },
    returnCarStateColor(state) {
      let result;
      if (state == 1) {
        if (this.$vuetify.theme && this.$vuetify.theme.dark) {
          result = "success_state_dark";
        } else {
          result = "success_state";
        }
      } else if (state == 2) {
        if (this.$vuetify.theme && this.$vuetify.theme.dark) {
          result = "secondary_state_dark";
        } else {
          result = "secondary_state";
        }
      } else if (state == 3) {
        if (this.$vuetify.theme && this.$vuetify.theme.dark) {
          result = "error_state_dark";
        } else {
          result = "error_state";
        }
      } else if (state == 4) {
        if (this.$vuetify.theme && this.$vuetify.theme.dark) {
          result = "pink_state_dark";
        } else {
          result = "pink_state";
        }
      } else if (state == 5) {
        if (this.$vuetify.theme && this.$vuetify.theme.dark) {
          result = "info_state_dark";
        } else {
          result = "info_state";
        }
      } else if (state == 6) {
        if (this.$vuetify.theme && this.$vuetify.theme.dark) {
          result = "warning_state_dark";
        } else {
          result = "warning_state";
        }
      } else if (state == 7) {
        if (this.$vuetify.theme && this.$vuetify.theme.dark) {
          result = "error_state_dark";
        } else {
          result = "error_state";
        }
      } else {
        result = "";
      }
      return result;
    },
    toggleFinanceMode() {
      this.$store.commit('setFinanceMode', !this.financeMode)
      this.loadBookings(moment().subtract(36, "hour").format("DD-MM-YYYY H:mm"), moment().add(34, "days").format("DD-MM-YYYY H:mm"), true, this.history_mode);
    },
    toggleFullscreen() {
      this.$refs["fullscreen"].toggle(); // recommended
      // this.fullscreen = !this.fullscreen // deprecated
    },
    fullscreenChange(fullscreen) {
      this.options.maxHeight = this.windowHeight + 50 + "px";
      this.fullscreen = fullscreen;
    },
    checkMobile() {
      this.windowHeight = window.innerHeight;
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
};
</script>

<style lang="css">
.pulse {
  border-radius: 50%;
  margin: 10px;
  height: 20px;
  width: 20px;
  transform: scale(1);
}

.pulse.pulse_success {
  background: rgba(0, 179, 0, 1);
  box-shadow: 0 0 0 0 rgba(0, 179, 0, 1);
  animation: pulse-green 2s infinite;
}

.pulse.pulse_error {
  background: rgb(239, 24, 24);
  box-shadow: 0 0 0 0 rgb(239, 24, 24);
  animation: pulse-error 2s infinite;
}

@keyframes pulse-green {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(51, 217, 178, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0);
  }
}

@keyframes pulse-error {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(217, 51, 51, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(217, 51, 51, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(217, 51, 51, 0);
  }
}

/* alternating column backgrounds */
/* .vis-item {
    border-color: orange;
    background-color: yellow;
  } */
.hidden {
  display: none;
}

:hover.hidden {
  display: block;
}

.vis-time-axis .vis-text {
  font-size: small;
}

.vis-time-axis .vis-grid.vis-minor {
  border-width: 2px;
  border-color: black !important;
}

.vis-time-axis .grid.vis-odd {
  background: #f5f5f5;
}

.vis-today {
  background: #afe3fc !important;
}

.dark .vis-today {
  background: #272727 !important;
}

/* gray background in weekends, white text color */
.vis-time-axis .vis-grid.vis-saturday,
.vis-time-axis .vis-grid.vis-sunday {
  background: rgba(231, 230, 230, 0.76);
}

.dark .vis-time-axis .vis-grid.vis-saturday,
.dark .vis-time-axis .vis-grid.vis-sunday {
  background: rgba(0, 0, 0, 0.02);
}

.vis-time-axis .vis-grid.vis-monday,
.vis-time-axis .vis-grid.vis-tuesday,
.vis-time-axis .vis-grid.vis-wednesday,
.vis-time-axis .vis-grid.vis-thursday,
.vis-time-axis .vis-grid.vis-friday {
  background: rgb(255, 255, 255);
}

.dark .vis-time-axis .vis-grid.vis-monday,
.dark .vis-time-axis .vis-grid.vis-tuesday,
.dark .vis-time-axis .vis-grid.vis-wednesday,
.dark .vis-time-axis .vis-grid.vis-thursday,
.dark .vis-time-axis .vis-grid.vis-friday {
  background: #272727;
}

.vis-major {
  background: rgba(231, 230, 230, 0.76);
}

.vis-top {
  background: rgba(255, 253, 253, 0.76);
}

.dark .vis-major {
  background: #272727;
}

.dark .vis-top {
  background: #272727;
}

.dark .vis-time-axis .vis-text {
  color: white;
}

/* Исправляет косяк с невидимостью!!! */
.vis-timeline {
  visibility: visible !important;
}

/* .vis-time-axis .vis-text.vis-saturday,
.vis-time-axis .vis-text.vis-sunday {
  color: white;
} */
.vis-item .vis-item-content {
  white-space: nowrap;
  box-sizing: border-box;
  padding: 5px;
  padding-left: 15px;
  font-size: medium;
}

.vis-item {
  border-radius: 17px !important;
}

/* .vis-item-overflow-group {
  margin-bottom: 3px !important;
} */
.vis-foreground .vis-group {
  position: relative;
  box-sizing: border-box;
  border-bottom: 2px solid black !important;
}

.vis-item.red {
  color: white;
  background-color: red;
  border-color: darkred;
}

.vis-item.booking_green {
  color: white;
  background-color: rgba(21, 180, 21, 0.8);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green {
  color: white;
  background-color: rgba(0, 179, 0, 1);
  border: black 1px solid !important;
}

.vis-item.booking_green_100 {
  color: white;
  background-color: rgba(21, 180, 21, 0.8);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_100 {
  color: white;
  background-color: rgba(0, 179, 0, 1);
  border: black 1px solid !important;
}

.vis-item.booking_green_99 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 99%, rgba(255, 0, 0, 0.6) 99%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_99 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 99%, rgba(255, 0, 0, 1) 99%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_98 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 98%, rgba(255, 0, 0, 0.6) 98%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_98 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 98%, rgba(255, 0, 0, 1) 98%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_97 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 97%, rgba(255, 0, 0, 0.6) 97%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_97 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 97%, rgba(255, 0, 0, 1) 97%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_96 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 96%, rgba(255, 0, 0, 0.6) 96%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_96 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 96%, rgba(255, 0, 0, 1) 96%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_95 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 95%, rgba(255, 0, 0, 0.6) 95%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_95 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 95%, rgba(255, 0, 0, 1) 95%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_94 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 94%, rgba(255, 0, 0, 0.6) 94%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_94 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 94%, rgba(255, 0, 0, 1) 94%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_93 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 93%, rgba(255, 0, 0, 0.6) 93%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_93 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 93%, rgba(255, 0, 0, 1) 93%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_92 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 92%, rgba(255, 0, 0, 0.6) 92%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_92 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 92%, rgba(255, 0, 0, 1) 92%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_91 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 91%, rgba(255, 0, 0, 0.6) 91%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_91 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 91%, rgba(255, 0, 0, 1) 91%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_90 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 90%, rgba(255, 0, 0, 0.6) 90%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_90 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 90%, rgba(255, 0, 0, 1) 90%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_89 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 89%, rgba(255, 0, 0, 0.6) 89%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_89 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 89%, rgba(255, 0, 0, 1) 89%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_88 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 88%, rgba(255, 0, 0, 0.6) 88%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_88 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 88%, rgba(255, 0, 0, 1) 88%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_87 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 87%, rgba(255, 0, 0, 0.6) 87%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_87 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 87%, rgba(255, 0, 0, 1) 87%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_86 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 86%, rgba(255, 0, 0, 0.6) 86%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_86 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 86%, rgba(255, 0, 0, 1) 86%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_85 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 85%, rgba(255, 0, 0, 0.6) 85%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_85 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 85%, rgba(255, 0, 0, 1) 85%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_84 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 84%, rgba(255, 0, 0, 0.6) 84%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_84 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 84%, rgba(255, 0, 0, 1) 84%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_83 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 83%, rgba(255, 0, 0, 0.6) 83%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_83 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 83%, rgba(255, 0, 0, 1) 83%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_82 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 82%, rgba(255, 0, 0, 0.6) 82%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_82 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 82%, rgba(255, 0, 0, 1) 82%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_81 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 81%, rgba(255, 0, 0, 0.6) 81%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_81 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 81%, rgba(255, 0, 0, 1) 81%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_80 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 80%, rgba(255, 0, 0, 0.6) 80%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_80 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 80%, rgba(255, 0, 0, 1) 80%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_79 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 79%, rgba(255, 0, 0, 0.6) 79%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_79 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 79%, rgba(255, 0, 0, 1) 79%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_78 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 78%, rgba(255, 0, 0, 0.6) 78%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_78 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 78%, rgba(255, 0, 0, 1) 78%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_77 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 77%, rgba(255, 0, 0, 0.6) 77%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_77 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 77%, rgba(255, 0, 0, 1) 77%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_76 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 76%, rgba(255, 0, 0, 0.6) 76%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_76 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 76%, rgba(255, 0, 0, 1) 76%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_75 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 75%, rgba(255, 0, 0, 0.6) 75%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_75 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 75%, rgba(255, 0, 0, 1) 75%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_74 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 74%, rgba(255, 0, 0, 0.6) 74%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_74 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 74%, rgba(255, 0, 0, 1) 74%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_73 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 73%, rgba(255, 0, 0, 0.6) 73%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_73 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 73%, rgba(255, 0, 0, 1) 73%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_72 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 72%, rgba(255, 0, 0, 0.6) 72%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_72 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 72%, rgba(255, 0, 0, 1) 72%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_71 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 71%, rgba(255, 0, 0, 0.6) 71%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_71 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 71%, rgba(255, 0, 0, 1) 71%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_70 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 70%, rgba(255, 0, 0, 0.6) 70%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_70 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 70%, rgba(255, 0, 0, 1) 70%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_69 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 69%, rgba(255, 0, 0, 0.6) 69%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_69 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 69%, rgba(255, 0, 0, 1) 69%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_68 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 68%, rgba(255, 0, 0, 0.6) 68%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_68 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 68%, rgba(255, 0, 0, 1) 68%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_67 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 67%, rgba(255, 0, 0, 0.6) 67%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_67 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 67%, rgba(255, 0, 0, 1) 67%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_66 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 66%, rgba(255, 0, 0, 0.6) 66%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_66 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 66%, rgba(255, 0, 0, 1) 66%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_65 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 65%, rgba(255, 0, 0, 0.6) 65%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_65 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 65%, rgba(255, 0, 0, 1) 65%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_64 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 64%, rgba(255, 0, 0, 0.6) 64%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_64 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 64%, rgba(255, 0, 0, 1) 64%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_63 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 63%, rgba(255, 0, 0, 0.6) 63%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_63 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 63%, rgba(255, 0, 0, 1) 63%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_62 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 62%, rgba(255, 0, 0, 0.6) 62%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_62 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 62%, rgba(255, 0, 0, 1) 62%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_61 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 61%, rgba(255, 0, 0, 0.6) 61%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_61 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 61%, rgba(255, 0, 0, 1) 61%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_60 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 60%, rgba(255, 0, 0, 0.6) 60%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_60 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 60%, rgba(255, 0, 0, 1) 60%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_59 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 59%, rgba(255, 0, 0, 0.6) 59%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_59 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 59%, rgba(255, 0, 0, 1) 59%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_58 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 58%, rgba(255, 0, 0, 0.6) 58%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_58 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 58%, rgba(255, 0, 0, 1) 58%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_57 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 57%, rgba(255, 0, 0, 0.6) 57%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_57 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 57%, rgba(255, 0, 0, 1) 57%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_56 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 56%, rgba(255, 0, 0, 0.6) 56%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_56 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 56%, rgba(255, 0, 0, 1) 56%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_55 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 55%, rgba(255, 0, 0, 0.6) 55%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_55 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 55%, rgba(255, 0, 0, 1) 55%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_54 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 54%, rgba(255, 0, 0, 0.6) 54%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_54 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 54%, rgba(255, 0, 0, 1) 54%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_53 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 53%, rgba(255, 0, 0, 0.6) 53%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_53 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 53%, rgba(255, 0, 0, 1) 53%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_52 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 52%, rgba(255, 0, 0, 0.6) 52%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_52 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 52%, rgba(255, 0, 0, 1) 52%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_51 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 51%, rgba(255, 0, 0, 0.6) 51%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_51 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 51%, rgba(255, 0, 0, 1) 51%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_50 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 50%, rgba(255, 0, 0, 0.6) 50%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_50 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 50%, rgba(255, 0, 0, 1) 50%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_49 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 49%, rgba(255, 0, 0, 0.6) 49%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_49 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 49%, rgba(255, 0, 0, 1) 49%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_48 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 48%, rgba(255, 0, 0, 0.6) 48%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_48 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 48%, rgba(255, 0, 0, 1) 48%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_47 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 47%, rgba(255, 0, 0, 0.6) 47%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_47 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 47%, rgba(255, 0, 0, 1) 47%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_46 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 46%, rgba(255, 0, 0, 0.6) 46%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_46 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 46%, rgba(255, 0, 0, 1) 46%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_45 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 45%, rgba(255, 0, 0, 0.6) 45%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_45 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 45%, rgba(255, 0, 0, 1) 45%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_44 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 44%, rgba(255, 0, 0, 0.6) 44%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_44 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 44%, rgba(255, 0, 0, 1) 44%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_43 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 43%, rgba(255, 0, 0, 0.6) 43%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_43 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 43%, rgba(255, 0, 0, 1) 43%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_42 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 42%, rgba(255, 0, 0, 0.6) 42%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_42 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 42%, rgba(255, 0, 0, 1) 42%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_41 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 41%, rgba(255, 0, 0, 0.6) 41%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_41 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 41%, rgba(255, 0, 0, 1) 41%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_40 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 40%, rgba(255, 0, 0, 0.6) 40%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_40 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 40%, rgba(255, 0, 0, 1) 40%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_39 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 39%, rgba(255, 0, 0, 0.6) 39%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_39 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 39%, rgba(255, 0, 0, 1) 39%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_38 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 38%, rgba(255, 0, 0, 0.6) 38%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_38 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 38%, rgba(255, 0, 0, 1) 38%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_37 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 37%, rgba(255, 0, 0, 0.6) 37%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_37 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 37%, rgba(255, 0, 0, 1) 37%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_36 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 36%, rgba(255, 0, 0, 0.6) 36%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_36 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 36%, rgba(255, 0, 0, 1) 36%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_35 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 35%, rgba(255, 0, 0, 0.6) 35%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_35 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 35%, rgba(255, 0, 0, 1) 35%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_34 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 34%, rgba(255, 0, 0, 0.6) 34%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_34 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 34%, rgba(255, 0, 0, 1) 34%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_33 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 33%, rgba(255, 0, 0, 0.6) 33%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_33 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 33%, rgba(255, 0, 0, 1) 33%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_32 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 32%, rgba(255, 0, 0, 0.6) 32%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_32 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 32%, rgba(255, 0, 0, 1) 32%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_31 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 31%, rgba(255, 0, 0, 0.6) 31%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_31 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 31%, rgba(255, 0, 0, 1) 31%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_30 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 30%, rgba(255, 0, 0, 0.6) 30%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_30 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 30%, rgba(255, 0, 0, 1) 30%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_29 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 29%, rgba(255, 0, 0, 0.6) 29%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_29 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 29%, rgba(255, 0, 0, 1) 29%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_28 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 28%, rgba(255, 0, 0, 0.6) 28%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_28 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 28%, rgba(255, 0, 0, 1) 28%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_27 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 27%, rgba(255, 0, 0, 0.6) 27%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_27 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 27%, rgba(255, 0, 0, 1) 27%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_26 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 26%, rgba(255, 0, 0, 0.6) 26%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_26 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 26%, rgba(255, 0, 0, 1) 26%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_25 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 25%, rgba(255, 0, 0, 0.6) 25%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_25 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 25%, rgba(255, 0, 0, 1) 25%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_24 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 24%, rgba(255, 0, 0, 0.6) 24%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_24 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 24%, rgba(255, 0, 0, 1) 24%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_23 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 23%, rgba(255, 0, 0, 0.6) 23%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_23 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 23%, rgba(255, 0, 0, 1) 23%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_22 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 22%, rgba(255, 0, 0, 0.6) 22%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_22 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 22%, rgba(255, 0, 0, 1) 22%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_21 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 21%, rgba(255, 0, 0, 0.6) 21%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_21 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 21%, rgba(255, 0, 0, 1) 21%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_20 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 20%, rgba(255, 0, 0, 0.6) 20%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_20 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 20%, rgba(255, 0, 0, 1) 20%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_19 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 19%, rgba(255, 0, 0, 0.6) 19%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_19 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 19%, rgba(255, 0, 0, 1) 19%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_18 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 18%, rgba(255, 0, 0, 0.6) 18%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_18 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 18%, rgba(255, 0, 0, 1) 18%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_17 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 17%, rgba(255, 0, 0, 0.6) 17%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_17 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 17%, rgba(255, 0, 0, 1) 17%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_16 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 16%, rgba(255, 0, 0, 0.6) 16%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_16 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 16%, rgba(255, 0, 0, 1) 16%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_15 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 15%, rgba(255, 0, 0, 0.6) 15%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_15 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 15%, rgba(255, 0, 0, 1) 15%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_14 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 14%, rgba(255, 0, 0, 0.6) 14%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_14 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 14%, rgba(255, 0, 0, 1) 14%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_13 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 13%, rgba(255, 0, 0, 0.6) 13%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_13 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 13%, rgba(255, 0, 0, 1) 13%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_12 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 12%, rgba(255, 0, 0, 0.6) 12%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_12 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 12%, rgba(255, 0, 0, 1) 12%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_11 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 11%, rgba(255, 0, 0, 0.6) 11%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_11 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 11%, rgba(255, 0, 0, 1) 11%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_10 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 10%, rgba(255, 0, 0, 0.6) 10%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_10 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 10%, rgba(255, 0, 0, 1) 10%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_9 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 9%, rgba(255, 0, 0, 0.6) 9%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_9 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 9%, rgba(255, 0, 0, 1) 9%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_8 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 8%, rgba(255, 0, 0, 0.6) 8%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_8 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 8%, rgba(255, 0, 0, 1) 8%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_7 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 7%, rgba(255, 0, 0, 0.6) 7%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_7 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 7%, rgba(255, 0, 0, 1) 7%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_6 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 6%, rgba(255, 0, 0, 0.6) 6%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_6 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 6%, rgba(255, 0, 0, 1) 6%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_5 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 5%, rgba(255, 0, 0, 0.6) 5%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_5 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 5%, rgba(255, 0, 0, 1) 5%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_4 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 4%, rgba(255, 0, 0, 0.6) 4%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_4 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 4%, rgba(255, 0, 0, 1) 4%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_3 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 3%, rgba(255, 0, 0, 0.6) 3%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_3 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 3%, rgba(255, 0, 0, 1) 3%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_2 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 2%, rgba(255, 0, 0, 0.6) 2%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_2 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 2%, rgba(255, 0, 0, 1) 2%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_1 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 128, 0, 0.8) 1%, rgba(255, 0, 0, 0.6) 1%, rgba(255, 0, 0, 0.6) 100%);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_1 {
  color: white;
  background: linear-gradient(to right, rgba(0, 128, 0, 1) 0%, rgba(0, 128, 0, 1) 1%, rgba(255, 0, 0, 1) 1%, rgba(255, 0, 0, 1) 100%);
  border: black 1px solid !important;
}

.vis-item.booking_green_0 {
  color: white;
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
  background: rgba(255, 0, 0, 0.7);
  border-color: #424242 !important;
}

:hover.vis-item.booking_green_0 {
  color: white;
  background: rgba(255, 0, 0, 1);
  border: black 1px solid !important;
}

.vis-item.booking_grey {
  color: rgb(0, 0, 0);
  background-color: rgba(128, 128, 128, 0.5);
  border-color: #424242 !important;
}

:hover.vis-item.booking_grey {
  color: rgb(0, 0, 0);
  background-color: rgba(128, 128, 128, 1);
  border-color: #424242 !important;
}

.vis-item.booking_warning {
  color: rgb(0, 0, 0);
  background-color: rgba(255, 165, 0, 0.5);
  border-color: #424242 !important;
}

:hover.vis-item.booking_warning {
  color: rgb(0, 0, 0);
  background-color: rgba(255, 165, 0, 1);
  border-color: #424242 !important;
}

.vis-item.booking_grey_green {
  color: rgb(0, 0, 0);
  background-color: rgba(124, 188, 127, 0.5);
  border-color: #424242 !important;
}

:hover.vis-item.booking_grey_green {
  color: rgb(0, 0, 0);
  background-color: rgba(124, 188, 127, 1);
  border-color: #424242 !important;
}

:hover.vis-item.booking_blue {
  color: white;
  background-color: rgba(59, 135, 229, 1);
  /* background: linear-gradient(to right, green 0%, green 80%, red 80%, red 100%); */
}

.vis-item.booking_blue {
  color: white;
  background-color: rgba(59, 135, 229, 0.9);
}

.vis-label.success_state a {
  color: #4caf50 !important;
  text-align: center !important;
  vertical-align: middle;
  text-decoration: none;
}

.vis-label.success_state_dark a {
  color: #4caf50 !important;
  text-align: center !important;
  vertical-align: middle;
  text-decoration: none;
}

.vis-label img {
  width: 18px;
  height: 18px;
}

.vis-label a {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  /* background-color: gray !important; */
  border-bottom: 1px solid black !important;
  margin-bottom: 3px;
}

.vis-label div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.vis-label div:nth-child(2) {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

/* plus */
.vis-label div:nth-child(3) {
  display: none;
}

.vis-label div:nth-child(3) a {
  border: none !important;
}

:hover.vis-label div:nth-child(3) {
  display: block;
  position: absolute;
  top: 50%;
  left: 90%;
  border: none;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  z-index: 100;
}

.vis-label {
  padding: 0 7px;
}

:hover.vis-label {
  background-color: rgba(59, 135, 229, 0.2);
}

/* .vis-group.success_state {
  background: rgba(76, 175, 80, 0.2);
} */
:hover.vis-group.success_state a {
  background: rgba(76, 175, 80, 0.5);
}

:hover.vis-group.success_state_dark a {
  background: rgba(76, 175, 80, 0.5);
}

.vis-label.secondary_state a {
  color: #424242 !important;
  text-align: center;
  vertical-align: middle;
  background: white;
  text-decoration: none;
}

.vis-label.secondary_state_dark a {
  color: #70706e !important;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
}

/* .vis-group.secondary_state {
  background: rgba(128, 128, 128, 0.2);
} */
:hover.vis-group.secondary_state {
  background: rgba(128, 128, 128, 0.5);
}

:hover.vis-group.secondary_state_dark {
  background: rgba(128, 128, 128, 0.5);
}

.vis-label.error_state a {
  color: red !important;
  text-align: center;
  vertical-align: middle;
  background: white;
  text-decoration: none;
}

.vis-label.error_state_dark a {
  color: red !important;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
}

/* .vis-group.error_state {
  background: rgba(255, 0, 0, 0.3);
} */
:hover.vis-group.error_state {
  background: rgba(255, 0, 0, 0.5);
}

:hover.vis-group.error_state_dark {
  background: rgba(255, 0, 0, 0.5);
}

.vis-label.pink_state a {
  color: #e91e63 !important;
  text-align: center;
  vertical-align: middle;
  background: white;
  text-decoration: none;
}

.vis-label.pink_state_dark a {
  color: #e91e63 !important;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
}

/* .vis-group.pink_state {
  background: rgba(233, 30, 99, 0.2);
} */
:hover.vis-group.pink_state {
  background: rgba(233, 30, 99, 0.5);
}

:hover.vis-group.pink_state_dark {
  background: rgba(233, 30, 99, 0.5);
}

.vis-label.info_state a {
  color: blue !important;
  text-align: center;
  vertical-align: middle;
  background: white;
  text-decoration: none;
}

.vis-label.info_state_dark a {
  color: blue !important;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
}

/* .vis-group.info_state {
  background: rgba(1, 1, 244, 0.2);
} */
:hover.vis-group.info_state {
  background: rgba(20, 20, 165, 0.5);
}

:hover.vis-group.info_state_dark {
  background: rgba(20, 20, 165, 0.5);
}

.vis-label.warning_state a {
  color: #ff9800 !important;
  text-align: center;
  vertical-align: middle;
  background: white;
  text-decoration: none;
}

.vis-label.warning_state_dark a {
  color: #ff9800 !important;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
}

/* .vis-group.warning_state {
  background: rgba(255, 152, 0, 0.2);
} */
:hover.vis-group.warning_state {
  background: rgba(255, 152, 0, 0.5);
}

:hover.vis-group.warning_state_dark {
  background: rgba(255, 152, 0, 0.5);
}

/* .vis-rolling-mode-btn:before {
  font-family: "Material Symbols Outlined";
  content: "\e15e";
} */
</style>
